// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__1cm0k","fillColor":"IconSuccess_fillColor__3milU"};